import { Icons, Button, notify, HexIcon, tokens } from '@cast/design-system';
import { useMarkSalesContactedMutation } from '@cast/shared-trial-data-access';
import { TrialBannerLayout, useTrial } from '@cast/shared-trial-ui';

import { openScheduleDialog } from 'core/integrations';
import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

export const TrialViewerBanner = () => {
  const accountReadOnly = useIsOrganizationReadOnly();
  const { isEligible } = useTrial();
  const { mutate: markSalesContacted } = useMarkSalesContactedMutation();

  if (!isEligible || !accountReadOnly) {
    return null;
  }

  const handleScheduleCall = () => {
    openScheduleDialog({
      onMeetingBooked: () => {
        markSalesContacted();
      },
      onError: () =>
        notify.error(
          'Failed to load the booking form. Please try again later.'
        ),
    });
  };

  return (
    <TrialBannerLayout
      testId="trial-viewer-banner"
      icon={
        <HexIcon
          icon={<Icons.ToggleRight />}
          size={58}
          iconColor={tokens.theme.fg.status.neutral}
          hexColor={tokens.theme.data.grey300}
        />
      }
      title="Premium feature no longer available"
      description="Your trial has ended, and Premium features are now view-only. To regain full access to all premium features, schedule a call with our team to discuss upgrade options."
      cta={
        <Button
          startIcon={<Icons.CalendarBlank />}
          onClick={handleScheduleCall}
        >
          Talk to us to upgrade
        </Button>
      }
    />
  );
};
